import { getSubStepValues } from '#models/general/steps';
import AdelphiFieldsRow from '#components/business/AdelphiFieldsRow';
import Input from '#components/general/Input';

import styles from './styles.module.scss';
import { SPIRIT_REDUCTION_SRWV_FIELDS, SPIRIT_REDUCTIONS_SUBSTEPS_IDS } from './constants';

export const getSRWVFirstPageFields = ({ values, errors }) => {
  const getSRWVValues = getSubStepValues(SPIRIT_REDUCTIONS_SUBSTEPS_IDS.SRWV_FIRST_PAGE, values, errors);
  return [
    {
      key: 'dip',
      Component: AdelphiFieldsRow,
      fieldContainerClassName: styles.mainInfoTableColumns,
      fields: [
        {
          ...getSRWVValues(SPIRIT_REDUCTION_SRWV_FIELDS.DIP_ORIGINAL),
          Component: Input,
          noMargin: true
        },
        {
          ...getSRWVValues(SPIRIT_REDUCTION_SRWV_FIELDS.BULK_ORIGINAL),
          Component: Input,
          noMargin: true
        }
      ]
    },
    {
      key: 'bulk',
      Component: AdelphiFieldsRow,
      fieldContainerClassName: styles.mainInfoTableColumns,
      fields: [
        {
          ...getSRWVValues(SPIRIT_REDUCTION_SRWV_FIELDS.TEMP_ORIGINAL),
          Component: Input,
          noMargin: true
        },
        {
          ...getSRWVValues(SPIRIT_REDUCTION_SRWV_FIELDS.IND_ORIGINAL),
          Component: Input,
          noMargin: true
        }
      ]
    },
    {
      key: 'temp',
      Component: AdelphiFieldsRow,
      fieldContainerClassName: styles.mainInfoTableColumns,
      fields: [
        {
          ...getSRWVValues(SPIRIT_REDUCTION_SRWV_FIELDS.STRENGTH_ORIGINAL),
          Component: Input,
          noMargin: true
        },
        {
          ...getSRWVValues(SPIRIT_REDUCTION_SRWV_FIELDS.TCF_ORIGINAL),
          Component: Input,
          noMargin: true
        }
      ]
    },
    {
      key: 'ind',
      Component: AdelphiFieldsRow,
      fieldContainerClassName: styles.mainInfoTableColumns,
      fields: [
        {
          ...getSRWVValues(SPIRIT_REDUCTION_SRWV_FIELDS.CBULK_ORIGINAL),
          Component: Input,
          noMargin: true
        },
        {
          ...getSRWVValues(SPIRIT_REDUCTION_SRWV_FIELDS.LALC_ORIGINAL),
          Component: Input,
          noMargin: true
        }
      ]
    }
  ];
};

export const getSRWVSecondPageFields = ({ values, errors }) => {
  const getSRWVValues = getSubStepValues(SPIRIT_REDUCTIONS_SUBSTEPS_IDS.SRWV_SECOND_PAGE, values, errors);
  return [
    {
      key: 'dip',
      Component: AdelphiFieldsRow,
      fieldContainerClassName: styles.mainInfoTableColumns,
      fields: [
        {
          ...getSRWVValues(SPIRIT_REDUCTION_SRWV_FIELDS.DIP_REDUCED),
          Component: Input,
          noMargin: true
        },
        {
          ...getSRWVValues(SPIRIT_REDUCTION_SRWV_FIELDS.BULK_REDUCED),
          Component: Input,
          noMargin: true
        }
      ]
    },
    {
      key: 'bulk',
      Component: AdelphiFieldsRow,
      fieldContainerClassName: styles.mainInfoTableColumns,
      fields: [
        {
          ...getSRWVValues(SPIRIT_REDUCTION_SRWV_FIELDS.TEMP_REDUCED),
          Component: Input,
          noMargin: true
        },
        {
          ...getSRWVValues(SPIRIT_REDUCTION_SRWV_FIELDS.IND_REDUCED),
          Component: Input,
          noMargin: true
        }
      ]
    },
    {
      key: 'temp',
      Component: AdelphiFieldsRow,
      fieldContainerClassName: styles.mainInfoTableColumns,
      fields: [
        {
          ...getSRWVValues(SPIRIT_REDUCTION_SRWV_FIELDS.STRENGTH_REDUCED),
          Component: Input,
          noMargin: true
        },
        {
          ...getSRWVValues(SPIRIT_REDUCTION_SRWV_FIELDS.TCF_REDUCED),
          Component: Input,
          noMargin: true
        }
      ]
    },
    {
      key: 'ind',
      Component: AdelphiFieldsRow,
      fieldContainerClassName: styles.mainInfoTableColumns,
      fields: [
        {
          ...getSRWVValues(SPIRIT_REDUCTION_SRWV_FIELDS.CBULK_REDUCED),
          Component: Input,
          noMargin: true
        },
        {
          ...getSRWVValues(SPIRIT_REDUCTION_SRWV_FIELDS.LALC_REDUCED),
          Component: Input,
          noMargin: true
        }
      ]
    }
  ];
};
